export default "__VITE_ASSET__BMgZE2dv__"